import {Component} from '@angular/core';
import {BaseSubcomp} from '../../../base-subcomp';

@Component({
    selector: 'app-conver-subcomp-parent',
    templateUrl: './conver-subcomp-parent.component.html',
    styleUrls: ['./conver-subcomp-parent.component.scss'],
    standalone: false
})
export class ConverSubcompParentComponent extends BaseSubcomp
{

}
